/* eslint-disable react/no-children-prop */
import React from 'react';
import { Input, InputGroup, InputProps, InputLeftElement } from '@chakra-ui/react';
import { MagnifyingGlass } from 'phosphor-react';

interface SearchFilterProps extends Omit<InputProps, 'onChange'> {
  // eslint-disable-next-line no-unused-vars
  onChange: (eventValue: string) => void;
}

export const SearchFilter = ({ onChange, ...rest }: SearchFilterProps) => {
  return (
    <InputGroup maxWidth="350px">
      <InputLeftElement
        pointerEvents="none"
        h="34px"
        w="34px"
        color="content.subtle"
        children={<MagnifyingGlass size={14} />}
      />
      <Input
        placeholder="Buscar"
        variant="outline"
        size="sm"
        pl="34px"
        onChange={(e) => onChange(e.target.value)}
        {...rest}
      />
    </InputGroup>
  );
};
